import _ from 'lodash';

let isEmptyCart = false;
if (!_.isNil(window.finishedOrder)) {
    isEmptyCart = true;
} else if (_.isNil(cart)) {
    isEmptyCart = true;
} else {
    let tmpCart = JSON.parse(cart);
    if (_.isNil(tmpCart.version)) {
        isEmptyCart = true;
    } else if (tmpCart.version != emptyCart.version) {
        isEmptyCart = true;
    }
}

let store = {
    state: {
        cart: isEmptyCart ? emptyCart: (JSON.parse(cart)),
    },
    props : {
        basketAddSuccessCall: null
    },
    mutations: {
        //licenceType - 0 = perpetual, 1 = lease
        //programType - local, network
        addToCart(state, payload) {
            let item = payload.item,
                licenceType = payload.licenceType,
                quantity = parseInt(payload.quantity) || 0;

            let displayQty = quantity.toString();
            if (quantity <= 0) {
                quantity = 0;
                displayQty = "";
            }

            //update cart object
            let found = -1;

            if (!_.isNil(state.cart.programs)) {
                found  =_.findIndex(state.cart.programs, function(pr) { return pr.id == item.id; });
            }

            if (found >= 0) {
                item[licenceType] = displayQty;
                state.cart.programs[found][licenceType] = quantity;
            } else {
                item[licenceType] = displayQty;
                state.cart.programs.push(item);
            }

            if (! (item.local_quantity || item.network_quantity || item.lease_local_quantity || item.lease_network_quantity || item.cloud_perpetual_quantity || item.cloud_time_quantity) ) {
                this.commit('removeFromCart', payload);
            }
            this.commit('emptyHardlocks');
            this.commit('saveCart');
            newCart.init();
        },
        upgradeCartProgram(state, payload) {
            if (!_.isNil(state.cart.programs)) {
                let found  =_.findIndex(state.cart.programs, function(pr) { return pr.id == payload.id; });
                if (found >= 0) {
                    state.cart.programs[found] = Object.assign(state.cart.programs[found], { [payload.column]: payload.upgrade });
                }
            }
            this.commit('saveCart');
        },
        removeFromCart(state, payload) {
            let item = payload.item;

            let found = state.cart.programs.find(product => product.id == item.id);
            let index = state.cart.programs.indexOf(found);

            if (index > -1) {
                //just remove from cart object
                state.cart.programs.splice(index, 1);
                if (typeof state.cart.programLanguages[item.id] != "undefined") {
                    delete state.cart.programLanguages[item.id];
                }
            }
            this.commit('saveCart');
        },
        addAdditionalLanguageToCart(state, payload) {
            let language = payload.selected,
                productId = payload.product;

            let index = state.cart.additionalLanguages[productId].indexOf(language);
            if (!(index > -1)) {
                state.cart.additionalLanguages[productId].push(language);
            }

            this.commit('saveCart');
        },
        addHardlockToCart(state, payload) {
            state.cart.hardlocks.push(payload);
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        removeHardlockFromCart(state, payload) {
            let id = payload.id;
            _.remove(state.cart.hardlocks, function(n) {
                return n.id == id;
            });
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        updateHardlock(state, payload) {
            let id = payload.id;
            let hardlock = _.find(state.cart.hardlocks, ['id', id]);
            if (!_.isEmpty(hardlock)) {
                _.remove(state.cart.hardlocks, function(n) {
                    return n.id == id;
                });
                state.cart.hardlocks.push(payload);
                window.localStorage.setItem('cart', JSON.stringify(state.cart));
            }

        },
        emptyHardlocks(state) {
            state.cart.hardlocks = [];
            state.cart.delivery = 0;
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        emptyLanguages(state) {
            state.cart.programLanguages = {};
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
            this.commit('saveCart');
        },
        setCartError(state, payload) {
            state.cart.cartError = payload;
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        setDealer(state, payload) {
            state.cart.dealerId = Number(payload.dealerId) || 0;
            this.commit('saveCart');
        },
        removeAdditionalLanguageToCart(state, payload) {
            let language = payload.selected,
                productId = payload.product;
            if (_.isNil(state.cart.additionalLanguages[productId])) {
                return false;
            }
            let index = state.cart.additionalLanguages[productId].indexOf(language);

            if (index > -1) {
                //just remove from cart object
                state.cart.additionalLanguages[productId].splice(index, 1);
            }
            this.commit('saveCart');
        },
        toggleMaintenance (state, payload) {
            let productId = payload.product;
            let price = payload.price;
            let status = ! state.cart.maintenance[productId].status;
            if (!_.isNil(payload.status)) {
                status = payload.status;
            }
            console.log(status);
            state.cart.maintenance[productId].status = status;

            state.cart.maintenance[productId].price = price;
            this.commit('saveCart');
        },
        resetMaintenance(state, payload) {
            state.cart.maintenance = {
                1: {
                    status: true,
                    price: 0
                },
                2: {
                    status: true,
                    price: 0
                }
            };
            this.commit('saveCart');
        },
        updateMaintenancePrice(state, payload) {
            let price = 0;

            if (!_.isUndefined(payload.price)) {
                price = Number(payload.price);
            }
            let productId = payload.product;

            state.cart.maintenance[productId].price = Number(price) || 0;
            if (!_.isUndefined(payload.totalCurrency)) {
                state.cart.maintenance[productId].totalCurrency = payload.totalCurrency;
            } else {
                state.cart.maintenance[productId].totalCurrency = {};
            }

            this.commit('saveCart');
        },

        toggleSingleUpgradePrice (state, payload) {
            state.cart.singleUpgrade[payload.product].total = payload.price;
            this.commit('saveCart');
        },
        toggleLeaseProlong (state, payload) {
            let status = false;
            if (!state.cart.leaseProlong.hasOwnProperty(payload)) {
                status = true;
            } else {
                status = ! state.cart.leaseProlong[payload]['status'];
            }
            state.cart.leaseProlong[payload].status = status;
            this.commit('saveCart');
        },
        toggleLeaseProlongPrice (state, payload) {
            state.cart.leaseProlong[payload.product].total = payload.price;
            this.commit('saveCart');
        },
        toggleSingleUpgradeProgram(state, payload) {
            let status = !state.cart.singleUpgrade[payload.product].info[payload.index].selected;
            if (_.isNil(payload.status)) {
                status = payload.status;
            }
            state.cart.singleUpgrade[payload.product].info[payload.index].selected = status;
            this.commit('saveCart');
        },
        toggleLeaseProlongProgram(state, payload) {
            state.cart.leaseProlong[payload.product].info[payload.index].selected = !state.cart.leaseProlong[payload.product].info[payload.index].selected;
            this.commit('saveCart');
        },
        updateLeaseProlongProgram(state, payload) {
            let item = _.find(state.cart.leaseProlong[payload.product].info, ['user_licence_id', payload.licenceId]);
            item.days = payload.days;
            this.commit('saveCart');
        },
        initSingleUpgrade(state, payload) {
            if (Object.keys(payload).length === 0) {
                Vue.set(state.cart.singleUpgrade, {});
            } else {
                state.cart.singleUpgrade[payload.product] = payload.data
            }
            this.commit('saveCart');
        },
        setKanUserInfo(state, payload) {
            Vue.set(state.cart, 'kanUserInfo', payload);
            this.commit('saveCart');
        },
        setHasDelivery(state, payload) {
            Vue.set(state.cart, 'hasDelivery', payload.hasDelivery);
            this.commit('saveCart');
        },
        setVatInfo(state, payload) {
            Vue.set(state.cart, 'vatInfo', payload.data);
            this.commit('saveCart');
        },
        setUserInfo(state, payload) {
            Vue.set(state.cart, 'userInfo', payload.data);
            this.commit('saveCart');
        },
        initLeaseProlong(state, payload) {
            if (Object.keys(payload).length === 0) {
                Vue.set(state.cart.leaseProlong, {});
            } else {
                state.cart.leaseProlong[payload.product] = payload.data
            }
            this.commit('saveCart');
        },
        addProgramLanguages(state, payload) {
            Vue.set(state.cart.programLanguages, payload.id, payload);
            this.commit('saveCart');
        },
        removeProgramLanguages(state, payload) {
            Vue.set(state.cart.programLanguages, payload.id, {});
            this.commit('saveCart');
        },
        removeAllProgramLanguages(state) {
            Vue.set(state.cart.programLanguages, {});
            this.commit('saveCart');
        },
        setSoftwareLanguages (state, payload) {
            state.cart.softwareLanguage = payload.languages;
            this.commit('saveCart', false);
        },
        saveCart(state, submit = 1) {
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        emptyCart(state) {
            state.cart = emptyCart;
            this.commit('saveCart', false);
        },
        setMustConfirm(state, payload) {
            state.cart.mustConfirm = payload;
            this.commit('saveCart');
        },
        setCartStep(state, payload) {
            state.cart.cartStep = payload.step ? payload.step : 1;
            state.cart.cartUpdate =  (state.cart.cartUpdate ?? 1) + 1;
            this.commit('saveCart', 0);
        },
        setUserNote(state, payload) {
            state.cart.userNote = payload.text;
            this.commit('saveCart', 0);
        },
        setDelivery(state, payload) {
            state.cart.delivery = payload.deliveryPrice ? payload.deliveryPrice : 0;
            this.commit('saveCart', 0);
        },
        changeLoggedInUser(state, payload) {
            state.cart.cartStep = 1;
            state.cart.loggedInUser = payload;
            state.cart.singleUpgrade = {};
            state.cart.leaseProlong = {};
            state.cart.programLanguages = {};
            state.cart.additionalLanguages = {
                1: [],
                2: []
            };
            this.commit('emptyHardlocks');
            this.commit('saveCart', 0);
        },
        setTrussPeriod(state, payload) {
            if (payload) {
                state.cart.trussPeriod = Number(payload);
                this.commit('saveCart');
            }
        },
        changeUserLevel(state, payload) {
            if (payload) {
                let userType = window.shopUserTypes.find(u => u.type == payload);
                state.cart.priceCoefficient = userType['cloudPriceCoefficient'] || 100;
                state.cart.userLevel = payload;
                state.cart.forceUserLevel = payload;
                this.commit('saveCart');
            }
        },
        setForcedUserType(state, payload) {
            if (payload) {
                state.cart.forceUserLevel = payload;
                this.commit('saveCart');
            }
        },
        changeExistingUserLevel(state, payload) {
            state.cart.existingUserLevel = payload;
            this.commit('saveCart');
        },
        addPromoLease(state, payload) {
            state.cart.subscriptionPromo = payload;
            this.commit('saveCart');
        },
        updateLeaseOptions(state, payload) {
            let id = payload.id;
            state.cart.leaseOptions[id] = payload.data;
            this.commit('saveCart');
        },
        createLeaseProlongConfig(state, payload) {
            state.cart.leaseProlongConfigs.push(payload);
            this.commit('saveCart');
        },
        deleteLeaseProlongConfig(state, payload) {
            state.cart.leaseProlongConfigs = _.reject( state.cart.leaseProlongConfigs, payload);
            this.commit('saveCart');
        },
        deleteLeasePerpetualUpgrade(state, payload) {
            state.cart.perpetualUpgrade = _.reject( state.cart.perpetualUpgrade, payload);
            this.commit('saveCart');
        },
        createLeasePerpetualUpgrade(state, payload) {
            state.cart.perpetualUpgrade.push(payload);
            this.commit('saveCart');
        },
        upgradeCartProgramProlong(state, payload) {
            if (!_.isNil(state.cart.leaseProlong[payload.product]['info'])) {

                let found  =_.findIndex(state.cart.leaseProlong[payload.product]['info'], function(pr) { return pr.user_licence_id === payload.user_licence_id; });
                if (found >= 0) {
                    state.cart.leaseProlong[payload.product]['info'][found] = Object.assign(state.cart.leaseProlong[payload.product]['info'][found], { [payload.column]: payload.upgrade });
                }
            }
            this.commit('saveCart');
        },
    }
};
function removeValueFromArray(arr, value) {
    let index = arr.indexOf(value);
    if (index > -1) {
        arr.splice(index, 1);
    }
    return arr;
}
export default store;
